// Unicode code-point counting (A12): astral-plane characters like emoji are
// 2 UTF-16 code units but must count as 1 character, matching the API's limit.
export const codepoints = (str) => [...str].length;

// Trims strings, passes everything else through unchanged (state fields like
// workspace_id can be "" or absent as well as a real string). Shared so a
// whitespace-only value is treated identically everywhere it's checked for
// presence — the payload builder, the wide-audience gate, and the review
// step's resolved-audience text.
export const trim = (value) => (typeof value === "string" ? value.trim() : value);

// Parses a comma/newline-separated blob of user IDs into a trimmed,
// de-duplicated array that preserves first-occurrence order (NOTIF-08).
export const parseUserIds = (raw) => {
  if (!raw) {
    return [];
  }

  const seen = new Set();
  const result = [];

  raw.split(/[,\n]/).forEach((piece) => {
    const trimmed = piece.trim();
    if (trimmed && !seen.has(trimmed)) {
      seen.add(trimmed);
      result.push(trimmed);
    }
  });

  return result;
};
